export default __webpack_public_path__ + "static/media/AboutIMG.66279c2f.png";